import type { IDecimalValueAndUnit, IDigestateJob, IDigestateJobForm, IJobSiteInfo } from '@/interfaces'
import Base from '../Base'
import { type JobStatusType } from '@/enum'
import JobSiteInfo from '../JobSiteInfo'
import PriceWithUnit from '../PriceWithUnit'

class DigestateJobForm extends Base implements IDigestateJobForm {
  status: JobStatusType
  description: string | null
  scheduleDate: string | null
  pickupADPlantSiteId: string | null
  collectionSiteInfo: IJobSiteInfo
  farmId: string | null
  siloId: string | null
  assignedEmployeeId: string | null
  assignedVehicleId: string | null
  assignedEquipmentId: string | null
  isRepeatable: boolean
  notes: string | null
  price: IDecimalValueAndUnit

  constructor(jobData?: IDigestateJob) {
    super(jobData)
    this.status = jobData?.status ?? 0
    this.description = jobData?.description ?? null
    this.scheduleDate = jobData?.scheduleDate ?? null
    this.pickupADPlantSiteId = jobData?.pickupADPlantSiteId ?? null
    this.collectionSiteInfo = new JobSiteInfo(jobData?.collectionSiteInfo) ?? new JobSiteInfo()
    this.farmId = jobData?.farmId ?? null
    this.siloId = jobData?.siloId ?? null
    this.assignedEmployeeId = jobData?.assignedEmployeeId ?? null
    this.assignedVehicleId = jobData?.assignedVehicleId ?? null
    this.assignedEquipmentId = jobData?.assignedEquipmentId ?? null
    this.isRepeatable = jobData?.isRepeatable ?? false
    this.notes = jobData?.notes ?? null
    this.price = new PriceWithUnit(jobData?.price)
  }
}

export default DigestateJobForm
